import { Component } from '@angular/core';

import { LocalizePipe } from '@accesso/cc-ui/pipes/localize';

import { STORE_LOCALES } from '../../core/localization/locales';

@Component({
	selector: 'app-not-found',
	imports: [LocalizePipe],
	template: `
		<div class="flex flex-col items-center gap-4 w-full p-4">
			<h1 class="small-form--title" data-cy="not-found-title">{{ LOCALES.common.pagenotfound | localize }}</h1>
			<img src="https://assets.accessocdn.com/assets/accesso/http_status_code_404.svg" alt="Not Found" />
			<div>
				<p data-cy="not-found-description">{{ LOCALES.common.pagenotfounddesc | localize }}</p>
			</div>
		</div>
	`,
})
export class NotFoundComponent {
	LOCALES = STORE_LOCALES;
}
